import { BasicWithLibelleModel } from '../basic/basicWithLibelle.model';
import { BasicModel } from '../basic/basic.model';
import { SsFamilleModel } from './ss-famille.model';
import { ActiviteModel } from './activite.model';

export class FamilleModel extends BasicModel implements BasicWithLibelleModel  {
    // required
    idActivite: number;
    activite: ActiviteModel;
    // required & max length 15
    code: string;
    // max length 80
    libelle: string;
    // liste de sous famille
    ssFamilles: SsFamilleModel[] = [];
}
